import axios from 'axios'
import React, {Fragment, useCallback, useEffect, useMemo, useState} from 'react'
import {Spinner} from 'react-bootstrap'
import Button from 'react-bootstrap/Button'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import {useTranslation} from 'react-i18next'
import {useNavigate} from 'react-router-dom'
import {authSelector} from 'src/redux/slices/authSlices'
import {setIsFetchData} from 'src/redux/slices/filterSlices'
import swal from 'sweetalert'
import {KTSVG} from '../../../../_metronic/helpers'
import {getAccessesEndUser} from '../../../../api/modules/access/access'
import {getProvince} from '../../../../api/modules/getdatalist'
import {
  createEndUser,
  deleteEndUser,
  detailEndUser,
  editEndUser,
  getCusGrup,
  getFilterCity,
} from '../../../../api/modules/master-data/master_2'
import {SelectPageSize} from '../../../../components/SelectPageSize/SelectPageSize'
import {StyledButtonGroups} from '../../../../components/StyledButtonGroups'
import {StyledCard} from '../../../../components/StyledCard'
import * as TableUI from '../../../../components/Table/Table'
import {HakAkses} from '../../../../components/mikro/getHakAkses'
import {useRowTable} from '../../../../hooks/useRowTable'
import {useAppDispatch, useAppSelector} from '../../../../redux/hooks'
import {
  endUserSelector,
  resetFilterEndUser,
  setFilter,
} from '../../../../redux/slices/endUserSlices'
import {getEndUsers, headers} from '../../../../services/fetcher'
import {objToParams} from '../../../../utils/objToParams'
import Pagination from '../../component/Pagination'
import CustomUseEffect from './CustomUseEffect'
import {RowData} from './RowData'
import {RowFilter} from './RowFilter'
import {RowHead} from './RowHead'

type Props = {
  className: string
}

const TableEndUser: React.FC<Props> = ({className}) => {
  const {roleId} = useAppSelector(authSelector)
  const {filter} = useAppSelector(endUserSelector)
  const dispatch = useAppDispatch()
  const {t} = useTranslation()
  const navigate = useNavigate()
  const hakAkses = HakAkses()

  const handleReloadTable = () => {
    dispatch(resetFilterEndUser())
    onFetchData()
  }

  const {RowEmptyData, RowErrorFetch, RowLoader} = useRowTable({
    colSpan: 10,
    onReloadTable: () => handleReloadTable(),
  })

  const [endUser, setEndUser] = useState<any[]>([])
  const [page, setPage] = useState(0)
  const [loading, setLoading] = useState(true)
  const [btnLoading, setBtnLoading] = useState(false)
  const [numberURL, setNumberURL] = useState([])
  const [accesses, setAccesses] = useState<any>()
  const [tempID, setTempID] = useState(0)
  const [showDelete, setShowDelete] = useState(false)
  const [showAdd, setShowAdd] = useState(false)
  const [showEdit, setShowEdit] = useState(false)
  const [actived, setActived] = useState(false)
  const [isError, setIsError] = useState(false)

  const rowNumber = useMemo(() => {
    const per = filter?.per_page ?? 5
    return page * per - per
  }, [page, filter?.per_page])

  const onFetchData = useCallback(() => {
    setLoading(true)
    setIsError(false)
    getEndUsers(filter)
      .then((res) => {
        setEndUser(res.data.data.data)
        setNumberURL(res.data.data.links)
        setPage(res.data.data.current_page)
      })
      .catch(() => setIsError(true))
      .finally(() => {
        setLoading(false)
        dispatch(setIsFetchData(false))
      })
  }, [filter])

  useEffect(() => {
    const getAccessMenu = async () => {
      setLoading(true)
      const res = await getAccessesEndUser(roleId)
      setAccesses(res.data.data)
    }

    getAccessMenu()
  }, [])

  const dropEnduser = async () => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        await deleteEndUser(tempID)
          .then((res) => {
            swal({
              title: t(res.data.message),
              icon: 'success',
            })
            setShowDelete(false)
          })
          .catch(function (error) {
            if (error.response) {
              swal({
                title: `${error.response.data.message}`,
                icon: 'error',
              })
            }
          })
          .finally(() => {
            setBtnLoading(false)
            // getEndUser()
            setActived(!actived)
          })
      }
    })
  }

  const paginateNumber = async (url: string) => {
    try {
      setLoading(true)

      const token = localStorage.getItem('token') as string
      const endpoint = `${url}&${objToParams({...filter})}`
      const res = await axios.get(endpoint, {
        headers: {...headers, Authorization: `Bearer ${token}`},
      })
      const data = res.data.data

      setEndUser(data.data)
      setPage(data.current_page)
      setNumberURL(data.links)
    } catch (error) {
      setIsError(true)
    } finally {
      setLoading(false)
    }
  }

  const [fullProvince, setFullProvince] = useState<any[]>([])
  const [fullCity, setFullCity] = useState([])
  const [fullSegment, setFullSegment] = useState([])

  const [name, setName] = useState('')
  const [alamat, setAlamat] = useState('')
  const [province, setProvince] = useState(0)
  const [city, setCity] = useState(0)
  const [ponsel, setPonsel] = useState('')
  const [email, setEmail] = useState('')
  const [segment, setSegment] = useState('')
  const [segmentCode, setSegmentCode] = useState('')
  const [bisnis, setBisnis] = useState('')
  const [status, setStatus] = useState(false)
  const [ObjEdit, setObjEdit] = useState<any>({})

  const handleClose = () => {
    setName('')
    setAlamat('')
    setProvince(0)
    setCity(0)
    setPonsel('')
    setEmail('')
    setSegment('')
    setSegmentCode('')
    setBisnis('')
    setStatus(false)
  }

  const handleSegment = (data: any) => {
    const tmp = data.split('-')
    setSegmentCode(tmp[0])
    setSegment(tmp[1])
  }

  useEffect(() => {
    const getAllProvince = async () => {
      await getProvince().then((res: any) => {
        setFullProvince(res.data.data)
      })
    }
    const getAllSegment = async () => {
      await getCusGrup().then((res: any) => {
        setFullSegment(res.data.data)
      })
    }
    getAllProvince()
    getAllSegment()
  }, [])

  CustomUseEffect(() => {
    const getFUllSalesOffice = async () => {
      await getFilterCity(province).then((res) => {
        setFullCity(
          res.data.data.map((item: any) => {
            return {
              id: item.id,
              value: item.value,
            }
          })
        )
      })
    }

    getFUllSalesOffice()
  }, [province])

  const handleCreateUser = async () => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Ya')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        const tmpStatus = status == false ? 0 : 1
        const payload = {
          name: name,
          status: tmpStatus,
          address: alamat,
          phone: ponsel,
          email: email,
          province_id: province,
          city_id: city,
          business_field: bisnis,
          segment_code: segmentCode,
          segment_name: segment,
        }
        await createEndUser(payload)
          .then((res: any) => {
            swal({
              title: `${t('Pengguna Berhasil di Tambahkan')}`,
              icon: 'success',
            }).then(() => navigate('/master/enduser'))
          })
          .catch((error: any) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
          .finally(() => {
            // getEndUser()
            setActived(!actived)
            setBtnLoading(false)
            setShowAdd(false)
          })
      }
    })
  }

  const handleShowEdit = async (id: any) => {
    let tmpProvinsi = 0
    await detailEndUser(id)
      .then((res) => {
        setObjEdit(res.data.data)
        setName(res.data.data.name)
        setAlamat(res.data.data.address)
        setProvince(parseInt(res.data.data.province?.id))
        setCity(parseInt(res.data.data.city?.id))
        setPonsel(res.data.data.phone)
        setEmail(res.data.data.email)
        setSegment(res.data.data.segment_name)
        setSegmentCode(res.data.data.segment_code)
        setBisnis(res.data.data.business_field)
        setStatus(res.data.data.status == 1 ? true : false)
        tmpProvinsi = res.data.data.province?.id
      })
      .finally(() => setShowEdit(true))

    await getFilterCity(tmpProvinsi).then((res) => {
      setFullCity(
        res.data.data.map((item: any) => {
          return {
            id: item.id,
            value: item.value,
          }
        })
      )
    })
  }

  const handleEdit = async (id: any) => {
    swal({
      title: `${t('Are You Sure?')}`,
      icon: 'warning',
      buttons: [`${t('Tidak')}`, `${t('Yes')}`],
      dangerMode: true,
    }).then(async (willDelete) => {
      if (willDelete) {
        setBtnLoading(true)
        const tmpStatus = status == false ? 0 : 1
        const payload = {
          name: name,
          status: tmpStatus,
          address: alamat,
          phone: ponsel,
          email: email,
          province_id: province,
          city_id: city,
          business_field: bisnis,
          segment_code: segmentCode,
          segment_name: segment,
        }
        await editEndUser(id, payload)
          .then((res: any) => {
            swal({
              title: `${t('Pengguna Berhasil di Ubah')}`,
              icon: 'success',
            }).then(() => navigate('/master/enduser'))
          })
          .catch((error: any) => {
            swal({
              closeOnClickOutside: false,
              title: t(error.response.data.message),
              icon: 'error',
            })
          })
          .finally(() => {
            setShowEdit(false)
            setBtnLoading(false)
            // getEndUser()
            setActived(!actived)
          })
      }
    })
  }

  const handleDelete = (id: number) => {
    setTempID(id)
    dropEnduser()
  }

  const handlePageSizeChange = (value: number | undefined | null) => {
    dispatch(setFilter({...filter, per_page: value ?? 5}))
  }

  useEffect(() => {
    const getData = setTimeout(onFetchData, 1000)
    return () => clearTimeout(getData)
  }, [onFetchData])

  useEffect(() => {
    return () => {
      handleReloadTable()
    }
  }, [])

  return (
    <StyledCard>
      <StyledButtonGroups
        leftContent={
          <SelectPageSize
            initialValue={filter?.per_page ?? 5}
            onChange={(value: any) => handlePageSizeChange(value?.value)}
          />
        }
        rightContent={
          hakAkses?.create && (
            <div className='card-toolbar' title={t('order-tambah') + ' ' + t('sub-order-endUser')}>
              <button
                className='btn btn-primary d-flex align-items-center'
                onClick={() => {
                  setShowAdd(true)
                }}
              >
                <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-3' />
                {t('order-tambah')}
              </button>
            </div>
          )
        }
      />

      <TableUI.TableWrapper>
        <TableUI.Table>
          <RowHead />
          <TableUI.TBody>
            <RowFilter />
            {loading ? (
              <RowLoader />
            ) : isError ? (
              <RowErrorFetch />
            ) : endUser.length === 0 ? (
              <RowEmptyData />
            ) : (
              endUser.map((item, index) => (
                <RowData
                  key={item?.id ?? index}
                  index={index}
                  rowNumber={index + 1 + rowNumber}
                  item={item}
                  onEdit={() => handleShowEdit(item?.id)}
                  onDelete={() => handleDelete(item?.id)}
                />
              ))
            )}
          </TableUI.TBody>
        </TableUI.Table>
      </TableUI.TableWrapper>

      <Pagination paginate={paginateNumber} test={numberURL} />

      <Modal
        show={showAdd}
        onHide={() => {
          setShowAdd(false)
          handleClose()
        }}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('order-tambah')} {t('End User')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('nama')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('nama')}
              onChange={(e: any) => setName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Address')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('Address')}
              onChange={(e: any) => setAlamat(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Province')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='provinsi'
              onChange={(e: any) => setProvince(e.target.value)}
            >
              <option value=''>
                {t('pilih')} {t('Province')}
              </option>
              {fullProvince.map((items: any, index: number) => (
                <option key={items?.id ?? index} value={items.id}>
                  {items.value}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('sub-order-kota')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='kota'
              onChange={(e: any) => setCity(e.target.value)}
            >
              <option value=''>
                {t('pilih')} {t('sub-order-kota')}
              </option>
              {fullCity.map((items: any, index: number) => (
                <option key={items?.id ?? index} value={items.id}>
                  {items.value}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Phone Number')}</Form.Label>
            <Form.Control
              type='number'
              placeholder={t('Phone Number')}
              onChange={(e: any) => {
                setPonsel(e.target.value)
              }}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='Email'
              onChange={(e: any) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Bidang Usaha')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('Bidang Usaha')}
              onChange={(e: any) => setBisnis(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('segment')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='segment'
              onChange={(e: any) => {
                handleSegment(e.target.value)
              }}
            >
              <option value=''>
                {t('pilih')} {t('segment')}
              </option>
              {fullSegment.map((items: any, index: number) => (
                <option key={items?.code ?? index} value={items.code + '-' + items.name}>
                  {items.name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Row className='mb-3 d-flex align-items-center'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('active')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Check
                  onClick={() => setStatus(!status)}
                  reverse
                  className='mt-5 mb-2'
                  type='checkbox'
                  id='ckbox'
                />
              </div>
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleCreateUser()} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('buat')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        show={showEdit}
        onHide={() => {
          setShowEdit(false)
          handleClose()
        }}
        backdrop='static'
        keyboard={false}
        centered
        scrollable
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {t('ubah')} {t('End User')}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('nama')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('nama')}
              defaultValue={name}
              onChange={(e: any) => setName(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Address')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('Address')}
              defaultValue={alamat}
              onChange={(e: any) => setAlamat(e.target.value)}
            />
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Province')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='provinsi'
              onChange={(e: any) => setProvince(e.target.value)}
            >
              <option value=''>
                {t('pilih')} {t('Province')}
              </option>
              {fullProvince.map((items: any, index: number) => (
                <Fragment key={items?.id ?? index}>
                  {province == items.id ? (
                    <option value={items.id} selected>
                      {items.value}
                    </option>
                  ) : (
                    <option value={items.id}>{items.value}</option>
                  )}
                </Fragment>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('sub-order-kota')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='kota'
              key={ObjEdit}
              onChange={(e: any) => setCity(e.target.value)}
            >
              <option value=''>
                {t('pilih')} {t('sub-order-kota')}
              </option>
              {fullCity.map((items: any) => (
                <>
                  {city == items.id ? (
                    <option value={items.id} selected>
                      {items.value}
                    </option>
                  ) : (
                    <option value={items.id}>{items.value}</option>
                  )}
                </>
              ))}
            </Form.Select>
          </Form.Group>

          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Phone Number')}</Form.Label>
            <Form.Control
              type='number'
              placeholder={t('Phone Number')}
              defaultValue={ponsel}
              onChange={(e: any) => {
                setPonsel(e.target.value)
              }}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>Email</Form.Label>
            <Form.Control
              type='email'
              placeholder='Email'
              defaultValue={email}
              onChange={(e: any) => setEmail(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('Bidang Usaha')}</Form.Label>
            <Form.Control
              type='text'
              placeholder={t('Bidang Usaha')}
              defaultValue={bisnis}
              onChange={(e: any) => setBisnis(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mb-5' controlId='formBasicEmail'>
            <Form.Label>{t('segment')}</Form.Label>
            <Form.Select
              aria-label='Default select example'
              id='segment'
              onChange={(e: any) => {
                handleSegment(e.target.value)
              }}
            >
              <option value=''>
                {t('pilih')} {t('segment')}
              </option>
              {fullSegment.map((items: any) => (
                <>
                  {segmentCode == items.code ? (
                    <option value={items.code + '-' + items.name} selected>
                      {items.name}
                    </option>
                  ) : (
                    <option value={items.code + '-' + items.name}>{items.name}</option>
                  )}
                </>
              ))}
            </Form.Select>
          </Form.Group>
          <Row className='mb-3 d-flex align-items-center'>
            <Col md='2'>
              <p className='fs-4 mt-2'>{t('active')}</p>
            </Col>
            <Col md='10'>
              <div className='d-flex align-items-center'>
                <Form.Check
                  onClick={() => setStatus(!status)}
                  reverse
                  className='mt-5 mb-2'
                  type='checkbox'
                  id='ckbox'
                  checked={status}
                />
              </div>
            </Col>
          </Row>
          <div className='d-flex justify-content-end'>
            <Button variant='primary' onClick={() => handleEdit(ObjEdit.id)} disabled={btnLoading}>
              {btnLoading ? <Spinner animation='border' variant='light' size='sm' /> : t('ubah')}
            </Button>
          </div>
        </Modal.Body>
      </Modal>
    </StyledCard>
  )
}

export {TableEndUser}
